export const DEFAULT_TWAP_NUMBER_OF_PARTS = 5;
export const MIN_TWAP_NUMBER_OF_PARTS = 2;
export const MAX_TWAP_NUMBER_OF_PARTS = 30;

export const DEFAULT_TWAP_DURATION = {
  minutes: 0,
  hours: 10,
};
